import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NavigationModal.css';
import { ROUTES } from '../constants/app';

function NavigationModal({ isOpen, onClose }) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleNavigation = (path) => {
    navigate(path);
    onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="navigation-modal-overlay" onClick={handleOverlayClick}>
      <div className="navigation-modal">
        
        <div className="navigation-modal-content">
          <div className="navigation-options">
            
            <button 
              className="navigation-option idcard-option"
              onClick={() => handleNavigation(ROUTES.START)}
            >
              <div className="option-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" fill="currentColor"/>
                </svg>
              </div>
              <div className="option-content">
                <h3>ID Card Kiosk</h3>
                <p>Print Employee ID cards</p>
              </div>
            </button>

            <button 
              className="navigation-option dashboard-option"
              onClick={() => handleNavigation(ROUTES.DASHBOARD)}
            >
              <div className="option-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" fill="currentColor"/>
                </svg>
              </div>
              <div className="option-content">
                <h3>Admin Dashboard</h3>
                <p>View employees, goodies and statistics</p>
              </div>
            </button>

          </div>
        </div>
      </div>
    </div>
  );
}

export default NavigationModal;
